var angular = require('angular')

angular.module('uniformCmp')
  .component('stepsFormWrapper', {
    template: require('./steps-form-wrapper.component.tpl.html'),
    controller: StepsFormWrapperCtrl,
    controllerAs: 'vm',
    bindings: {
      formFields: '<',
      values: '=',
      stepId: '<',
      currentStep: '<',
      attachmentNames: '=',
      fileContents: '<',
      resetStepValidity: '&'
    }
  })

StepsFormWrapperCtrl.$inject = ['wcmDocumentDataservice']

function StepsFormWrapperCtrl (wcmDocumentDataservice) {
  var vm = this

  vm.$onInit = function () {
    vm.resetFieldsValidity = resetFieldsValidity
  }

  function resetFieldsValidity () {
    vm.resetStepValidity()
  }
}
